import { create } from 'zustand';

import type { DashboardPeriod } from './period';

interface DashboardPeriodState {
  period: DashboardPeriod | null;
  setPeriod: (period: DashboardPeriod) => void;
  resetPeriod: () => void;
}

export const useDashboardPeriodStore = create<DashboardPeriodState>()((set) => ({
  period: null,
  setPeriod: (period) => set({ period }),
  resetPeriod: () => set({ period: null }),
}));
